import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Repeat, Calendar, CheckCircle2, Shield } from "lucide-react";

export default function DirectDebitsPage() {

  return (
    <div className="flex-1 space-y-4 p-4 md:p-6 pt-6">
      {/* Main Coming Soon Card */}
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="max-w-2xl w-full">
          <CardHeader className="text-center space-y-4 pb-8">
            <div className="mx-auto h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center">
              <Repeat className="h-10 w-10 text-primary" />
            </div>
            <div className="space-y-2">
              <Badge variant="secondary" className="mb-2">
                Coming Soon
              </Badge>
              <CardTitle className="text-3xl">Direct Debits</CardTitle>
              <CardDescription className="text-base">
                This feature is currently under development and will be available soon
              </CardDescription>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center space-y-2">
              <p className="text-muted-foreground">
                We're building a comprehensive direct debit management system that will allow you to:
              </p>
            </div>

            {/* Feature Preview */}
            <div className="grid gap-4 md:grid-cols-2 pt-4">
              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Repeat className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Automated Collections</h3>
                  <p className="text-sm text-muted-foreground">
                    Set up recurring payments to collect automatically from customer bank accounts
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Mandate Management</h3>
                  <p className="text-sm text-muted-foreground">
                    Manage customer authorizations and direct debit mandates securely
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Calendar className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Flexible Scheduling</h3>
                  <p className="text-sm text-muted-foreground">
                    Configure monthly, quarterly, or annual payment schedules
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <CheckCircle2 className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Payment Tracking</h3>
                  <p className="text-sm text-muted-foreground">
                    Monitor payment status and automatically reconcile collections
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
